module.exports = __webpack_public_path__ + "aca8238a184d24e696e120b95999840f.svg";